import { render } from "./DateFilter.vue?vue&type=template&id=d2ec0986&ts=true"
import script from "./DateFilter.vue?vue&type=script&lang=ts"
export * from "./DateFilter.vue?vue&type=script&lang=ts"

import exportComponent from "/app/ViewpointPBIEmbedded/ViewpointPBIEmbedded.BFF/ClientApp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__